import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ProgrammingUtilsService as Utils } from './../../common/services/utils.service';
import { SharedProgrammingService, CommonProgrammingContext } from '../../common/services/shared-programming.service';
import { BaseRoutingComponent } from '../../common/base-routing/base-routing.component';
import { Event } from '../../common/interfaces/event.interface';
import { ScheduleQuickstartContext } from '../quickstart-schedule/services/schedule.service';

@Component({
  selector: 'prg-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.less']
})
export class EventComponent extends BaseRoutingComponent implements OnInit {

  title: Observable<string>;
  editing: Observable<boolean>;
  ready: Observable<boolean>;
  event: Observable<Event>;
  expanded: Observable<boolean>;
  adding: Observable<boolean>;

  constructor(
    protected router: Router,
    protected shared: SharedProgrammingService,
    private utils: Utils,
    protected store: Store<{
      sharedProgramming: CommonProgrammingContext,
      scheduleProgramming: ScheduleQuickstartContext
    }>,
    private route: ActivatedRoute
  ) {
    super();
    this.event = this.store.select(s => s.sharedProgramming.trigger.event).distinctUntilChanged();
    this.title = this.store.select(s => s.sharedProgramming.viewTitle).distinctUntilChanged();
    this.editing = this.store.select(s => s.sharedProgramming.editing).distinctUntilChanged();
    this.adding = this.store.select(s => s.sharedProgramming.adding).distinctUntilChanged();
    this.expanded = this.store.select(s => s.sharedProgramming.eventExpanded).distinctUntilChanged();

    this.ready = Observable.combineLatest(
      this.store.select(s => s.sharedProgramming.ready),
      this.store.select(s => s.scheduleProgramming.ready),
      (a, b) => (a && b)
    ).distinctUntilChanged();
  }

  ngOnInit() {
    this.shared.clearError();
    // console.log('event.cmp: event in context on init: ', Utils.snapshot(this.event));

    this.route.params.take(1).subscribe((params: any) => {
      // console.log('event.cmp: oninit: route params', params);
      // NOTE route params are strings
      let eid = parseInt(params.eventId);
      let did = parseInt(params.deviceId);
      // NOTE new scheduler events will have eventId=0, we don't want to refresh in this case
      if (!isNaN(eid) && !isNaN(did) && eid && did) {
        // console.log('event.cmp: refreshing trigger');
        this.shared.fetchEvent(did, eid);
      }
    });
  }

  isActive(path: string): boolean {
    return (window.location.href.indexOf(path) >= 0);
  }

  toggleExpand() {
    this.shared.toggleEventExpanded();
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/event/event.component.ts